import { APPLY_COUPON, COUPON_ERROR, REMOVE_ONE_COUPON, CLEAR_PENDING_APPLIED_COUPON } from "./actionTypes";

// Single coupon only: either one vendor (store) coupon OR one platform (Zaaapit) promo coupon. vendors = { [restaurant_id]: couponObj }, elevate = single.
// pendingAppliedCouponForCart: set when apply succeeds (e.g. from CouponList) so Cart on mount can run light path and fetch bill
const initialState = {
	coupon: {
		vendors: {}, // { [restaurant_id]: couponObj }
		elevate: null,
		coupon: null, // primary for backward compat: first vendor or elevate
	},
	pendingAppliedCouponForCart: null,
	coupon_error: "",
};

function primaryCoupon(vendors, elevate) {
	const firstVendor = vendors && typeof vendors === "object" ? Object.values(vendors)[0] : null;
	return firstVendor || elevate || null;
}

export default function (state = initialState, action) {
	switch (action.type) {
		case APPLY_COUPON: {
			const payload = action.payload;
			if (payload && payload.hideMessage) {
				return {
					...state,
					coupon: { vendors: {}, elevate: null, coupon: null },
				};
			}
			if (payload && payload.success) {
				const isElevate =
					payload.coupon_applied_to &&
					String(payload.coupon_applied_to).toLowerCase() === "elevate";
				if (isElevate) {
					// Only one coupon: platform promo applied → clear all vendor coupons
					const next = {
						vendors: {},
						elevate: payload,
						coupon: payload,
					};
					return { ...state, coupon: next, pendingAppliedCouponForCart: payload };
				}
				// Vendor coupon: only one coupon → clear platform promo, set this vendor only
				const rid = payload.restaurant_id != null ? Number(payload.restaurant_id) : null;
				const nextVendors = {};
				if (rid != null && !Number.isNaN(rid)) {
					nextVendors[rid] = payload;
				}
				const next = {
					vendors: nextVendors,
					elevate: null,
					coupon: nextVendors[rid] || null,
				};
				return { ...state, coupon: next, pendingAppliedCouponForCart: payload };
			}
			return { ...state, coupon: { ...state.coupon, coupon: payload || state.coupon.coupon } };
		}
		case REMOVE_ONE_COUPON: {
			const key = action.payload;
			if (key === "elevate" || key === "ELEVATE") {
				const next = {
					...state.coupon,
					elevate: null,
					coupon: primaryCoupon(state.coupon.vendors, null),
				};
				return { ...state, coupon: next };
			}
			if (typeof key === "number" || (typeof key === "string" && key !== "" && !Number.isNaN(Number(key)))) {
				const rid = typeof key === "number" ? key : Number(key);
				const nextVendors = { ...(state.coupon.vendors || {}) };
				delete nextVendors[rid];
				const next = {
					...state.coupon,
					vendors: nextVendors,
					coupon: primaryCoupon(nextVendors, state.coupon.elevate),
				};
				return { ...state, coupon: next };
			}
			return state;
		}
		case COUPON_ERROR:
			return { ...state, coupon_error: action.payload };

		case CLEAR_PENDING_APPLIED_COUPON:
			return { ...state, pendingAppliedCouponForCart: null };

		default:
			return state;
	}
}
